//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Converter } from 'opencc-js';
export default {
    props: ['product'],
    data() {
        return {
	locale:"EN",
        }
    },
    created() {	
			console.log('home...');
			const locale= this.$i18n.locale 
			console.log('locale',locale);
			this.locale = locale
	 
	
	},
    methods: {
        detail(id) {
            this.$router.push({ path:'/product', query:{id}})
        }
    }
}
